var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{attrs:{"id":"home-footer","color":"grey darken-4","dark":"","min-height":"72"}},[_c('v-container',[_c('v-row',[_c('v-spacer'),_c('v-col',{staticClass:"text-center text-md-right",attrs:{"cols":"12","md":"6"}},[_vm._v(" Copyright © 2020 DoShip Pvt Ltd ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }